import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ShoppingCart, Eye, CreditCard, AlertTriangle, Link as LinkIcon } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

// --- AKILLI API ADRES SEÇİCİ ---
const getBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }
  return ''; // Canlı sitede boş bırakılır ki kendi domainini kullansın
};

const API = `${getBaseUrl()}/api`;

const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${getBaseUrl()}${url}`;
};

const getCurrencySymbol = (code) => {
  switch(code) {
    case 'USD': return '$';
    case 'EUR': return '€';
    case 'GBP': return '£';
    case 'BTC': return '₿';
    case 'ETH': return 'Ξ';
    default: return '₺';
  }
};

const ServiceDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [service, setService] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log(`Bağlanılıyor: ${API}/services/${id}`); 

        // 1. Hizmet Detayını Çek
        const serviceRes = await fetch(`${API}/services/${id}`);
        if (!serviceRes.ok) {
           throw new Error(serviceRes.status === 404 ? 'Hizmet veritabanında bulunamadı.' : 'Sunucu hatası.');
        }
        const serviceData = await serviceRes.json();
        setService(serviceData);

        // 2. Ürünleri Çek
        const productsRes = await fetch(`${API}/products?service_id=${id}`);
        const productsData = await productsRes.json();
        setProducts(productsData || []);
        
        setLoading(false);
      } catch (err) {
        console.error("Detay Sayfası Hatası:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    if (id) fetchData();
    window.scrollTo(0, 0);
  }, [id]);

  if (loading) return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
       <p>Veriler Yükleniyor...</p>
    </div>
  );

  if (error || !service) return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
       <AlertTriangle size={64} className="text-red-500 mb-4" />
       <h2 className="text-2xl font-bold mb-2">Hizmet Görüntülenemedi</h2>
       <p className="text-gray-400 mb-6">
         {error || "Aradığınız hizmet silinmiş veya yayından kaldırılmış olabilir."}
       </p>
       <button onClick={() => navigate('/services')} className="bg-white text-black px-6 py-3 rounded-full font-bold hover:bg-gray-200 transition">
          Hizmetlere Dön
       </button>
    </div>
  );

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <div className="pt-32 px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          
          <button onClick={() => navigate('/services')} className="mb-8 flex items-center gap-2 text-gray-400 hover:text-white transition">
            <ArrowLeft size={20} /> Tüm Hizmetler
          </button>

          <div className="mb-16 text-center">
            <motion.h1 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-4xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600"
            >
              {language === 'tr' ? service.title_tr : service.title_en}
            </motion.h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              {language === 'tr' ? service.description_tr : service.description_en}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-blue-500/50 transition group flex flex-col h-full shadow-lg"
              >
                <div className="relative h-56 overflow-hidden">
                  <img 
                    src={getImageUrl(product.image_url)} 
                    alt={product.name_tr} 
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                    onError={(e) => {e.target.src = 'https://via.placeholder.com/400?text=Resim+Yok'}}
                  />
                  <div className="absolute top-3 right-3 bg-black/80 backdrop-blur text-white px-3 py-1 rounded-lg text-sm font-bold border border-gray-700">
                     {product.price} {getCurrencySymbol(product.currency)}
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold mb-2 text-white line-clamp-1 group-hover:text-blue-400 transition">
                    {language === 'tr' ? product.name_tr : product.name_en}
                  </h3>
                  <p className="text-gray-400 text-sm mb-6 line-clamp-2 flex-grow">
                    {language === 'tr' ? product.description_tr : product.description_en}
                  </p>

                  {/* ==================================================== */}
                  {/* DİNAMİK V3.0 BUTON SİSTEMİ BURADA BAŞLIYOR           */}
                  {/* ==================================================== */}
                  <div className="flex gap-3 mt-auto">
                    
                    {/* 1. SOL BUTON: HER ZAMAN İNCELEME (DETAY) SAYFASINA GİDER */}
                    <Link 
                      to={`/product/${product.slug || product.id}`} 
                      className="flex-1 bg-gray-800 hover:bg-gray-700 text-white py-3 rounded-xl flex items-center justify-center gap-2 transition text-sm font-medium border border-gray-700"
                    >
                      <Eye size={18} /> {language === 'tr' ? 'Detaylar' : 'Details'}
                    </Link>

                    {/* 2. SAĞ BUTON: ADMİN PANELİNDEN GELEN DİNAMİK BUTON */}
                    {product.button_action_type === 'external' && product.external_link ? (
                       <a 
                         href={product.external_link} 
                         target="_blank" 
                         rel="noreferrer"
                         className="flex-1 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white py-3 rounded-xl flex items-center justify-center gap-2 transition text-sm font-bold shadow-lg shadow-blue-900/20"
                       >
                         <LinkIcon size={18} /> 
                         {language === 'tr' ? (product.button_text_tr || 'Satın Al') : (product.button_text_en || 'Buy')}
                       </a>
                    ) : product.payment_link ? (
                       /* Geriye Dönük Uyumluluk (Eski Payment Link Varsa) */
                       <a 
                         href={product.payment_link} 
                         target="_blank" 
                         rel="noreferrer"
                         className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white py-3 rounded-xl flex items-center justify-center gap-2 transition text-sm font-bold shadow-lg shadow-green-900/20"
                       >
                         <CreditCard size={18} /> 
                         {language === 'tr' ? (product.button_text_tr || 'Satın Al') : (product.button_text_en || 'Buy')}
                       </a>
                    ) : (
                       /* İç Link Seçiliyse Detay Sayfasına Gider */
                       <Link 
                         to={`/product/${product.slug || product.id}`}
                         className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl flex items-center justify-center gap-2 transition text-sm font-bold shadow-lg shadow-blue-900/20"
                       >
                         <ShoppingCart size={18} /> 
                         {language === 'tr' ? (product.button_text_tr || 'Sipariş Ver') : (product.button_text_en || 'Order')}
                       </Link>
                    )}
                  </div>
                  {/* ==================================================== */}

                </div>
              </motion.div>
            ))}
          </div>

          {products.length === 0 && (
             <div className="text-center text-gray-500 mt-12 bg-gray-900/50 p-8 rounded-xl border border-gray-800">
                <p>Bu hizmet altında henüz listelenen bir ürün bulunmamaktadır.</p>
             </div>
          )}

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetailPage;